import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getBlModeList(params) {
  return request({
    url: URL.mdm.basicData.blMode,
    method: 'get',
    params
  })
}

export function getBlModesByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformBlMode,
    method: 'get',
    params
  })
}

export function getAllBlModeTemplate(params) {
  return request({
    url: URL.mdm.basicData.blModeTemplate,
    method: 'get',
    params
  })
}

export function saveBlMode(data) {
  return request({
    url: URL.mdm.basicData.blMode,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addBlModeByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformBlMode,
    method: 'post',
    data
  })
}

export function saveBlModes(data) {
  return request({
    url: URL.mdm.basicData.blModes,
    method: 'post',
    data
  })
}

export function delBlMode(uuid) {
  return request({
    url: URL.mdm.basicData.blMode + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
